<template>
    <div>
        <AboveTable
            :heading="heading"
            :filters="filters"
            :active-filter="currentFilter"
            :create-link="`${urlBase}/create`"
            :current-search="currentSearch"
            :export-link="exportLink"
            @search="searchHandler"
            @filterChanged="filterChanged"
        />
        <Table
            v-if="isLoading || (items && items.length > 0)"
            :headers="headers"
            :items="items"
            :totalPages="totalPages"
            :currentPage="currentPage"
            @changePage="changePage"
        >
            <template slot-scope="{ item }">
                <td
                    v-for="header in headers"
                    :key="header.property"
                >
                    <component
                        :is="header.link && !item.deleted_at ? 'router-link' : 'span'"
                        :to="header.link ? `${urlBase}/${item.id}` : null"
                        :class="header.link && !item.deleted_at ? 'link' : ''"
                    >
                        {{ item[header.property] }}
                    </component>
                </td>
                <TableButtons
                    :edit="!item.deleted_at ? `${urlBase}/${item.id}` : null"
                    :show-restore="!!item.deleted_at"
                    @delete="dialog = item.id"
                    @restore="restoreItem(item.id)"
                />
            </template>
        </Table>
        <div
            v-if="!isLoading && items.length < 1"
            class="noItemsFound"
        >
            No posts found.
        </div>
        <portal to="endOfPage">
            <DialogAction
                v-if="dialog"
                :heading="dialogText.heading"
                :text="dialogText.body"
                accept-text="Ta bort"
                @accept="deleteItem(dialog)"
                @close="dialog = null"
            />
        </portal>
    </div>
</template>

<script>
import Table from './Table.vue';
import TableButtons from './TableButtons.vue';
import AboveTable from './AboveTable.vue';
import DialogAction from '../dialog/DialogAction.vue';
import { get, remove, update } from '../../utils/apiHelper';

export default {
    components: {
        Table,
        TableButtons,
        AboveTable,
        DialogAction,
    },
    props: {
        apiBase: {
            type: String,
            required: true,
        },
        urlBase: {
            type: String,
            required: true,
        },
        heading: {
            type: String,
            required: true,
        },
        headers: {
            type: Array,
            required: true,
        },
        dialogText: {
            type: Object,
            required: true,
        },
        exportLink: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        currentPage: 1,
        currentFilter: 'all',
        totalPages: null,
        dialog: null,
        currentSearch: null,
        items: [],
        isLoading: true,
        filters: [
            { label: 'All', value: 'all' },
            { label: 'Trashed', value: 'trashed' },
        ],
    }),
    async created() {
        this.currentPage = this.$route.query.page ? this.$route.query.page : 0;
        this.currentSearch = this.$route.query.search ? this.$route.query.search : null;
        this.currentFilter = this.$route.query.filter ? this.$route.query.filter : 'all';

        if (!this.currentSearch) {
            this.getPage();
        }
    },
    methods: {
        filterChanged(filter) {
            this.currentPage = 1;
            this.currentFilter = filter;
            this.currentSearch = null;

            this.setUrl();
            this.getPage();
        },
        changePage(page) {
            this.currentPage = page;

            this.setUrl();
            this.getPage();
        },
        setUrl() {
            const query = {};

            if (this.currentPage > 1 && !this.currentSearch) {
                query.page = this.currentPage;
            }

            if (this.currentSearch && this.currentSearch.length > 0) {
                query.search = this.currentSearch;
            }

            if (this.currentFilter === 'trashed') {
                query.filter = this.currentFilter;
            }

            this.$router.replace({ name: this.$route.name, query });
        },
        async searchHandler(query) {
            this.isLoading = true;
            this.currentSearch = query;

            if (!query) {
                this.changePage(1);
                return;
            }

            const res = await get(`/api/${this.apiBase}/search`, {
                filter: this.currentFilter,
                query,
            });

            this.totalPages = null;
            this.items = res;
            this.setUrl();
            this.isLoading = false;
        },
        async getPage() {
            this.isLoading = true;

            const res = await get(`/api/${this.apiBase}`, {
                page: this.currentPage,
                filter: this.currentFilter,
            });
            this.currentPage = res.current_page;
            this.items = res.data;
            this.totalPages = res.last_page;

            this.isLoading = false;
        },
        async deleteItem(id) {
            this.dialog = false;
            const index = await remove(`/api/${this.apiBase}/${id}`, this.items, id);

            if (index || index === 0) {
                this.items.splice(index, 1);
            }
        },
        async restoreItem(id) {
            const res = await update(`/api/${this.apiBase}/restore/${id}`);

            if (res) {
                const restoredItem = this.items.find(item => item.id === id);
                const index = this.items.indexOf(restoredItem);

                if (index || index === 0) {
                    this.items.splice(index, 1);
                }
            }
        },
    },
};
</script>

<style lang="postcss" scoped>
.noItemsFound {
    padding: 20px;
    box-shadow: var(--shadow);
    background-color: #fff;
    border-radius: var(--borderRadius);
}
</style>
